import RuntimeError from '@/class/error/RuntimeError'
/**
 * 错误提示（弹窗参数）
 */
export class ErrorTip extends RuntimeError {
  /**
	 * @param {String} message 消息文字
	 * @param {String} type 主题
	 */
  constructor(message, type = 'warning', code = 1001) {
    super(message, code, type)
  }
}

export default ErrorTip
